export const LOYALTY_ENROLLMENT_TYPE = {
  AUTOMATIC: 0,
  MANUAL: 1,
};

export const isAutomaticEnrollmentType = (enrollmentType) =>
  Number(enrollmentType) === LOYALTY_ENROLLMENT_TYPE.AUTOMATIC;

export const isManualEnrollmentType = (enrollmentType) =>
  Number(enrollmentType) === LOYALTY_ENROLLMENT_TYPE.MANUAL;

